import { CookieService } from './cookie.service';
export function cookieServiceFactory(cookieOptionsProvider) {
    return new CookieService(cookieOptionsProvider);
}



//////////////////
// WEBPACK FOOTER
// ./~/ngx-cookie/src/cookie.factory.js
// module id = 1502
// module chunks = 2